var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex items-center w-full" },
    [
      _c("FormInputGroup", {
        staticClass: "h-input w-24",
        attrs: {
          id: "min",
          type: "number",
          placeholder: "Min",
          name: "min",
          value: _vm.minValue,
          svgPrefix: `yes`,
          debounceTime: 500,
          iconStyle: _vm.iconStyle,
          inputClass: _vm.inputClass,
          inputClasses: _vm.inputClasses,
          prefix: _vm.prefix,
          suffix: _vm.suffix,
        },
        on: {
          input: function ($event) {
            return _vm.handleInput("minValue", $event)
          },
        },
      }),
      _vm._m(0),
      _c("FormInputGroup", {
        staticClass: "h-input w-24",
        attrs: {
          id: "max",
          type: "number",
          name: "max",
          placeholder: "Max",
          svgPrefix: `yes`,
          value: _vm.maxValue,
          iconStyle: _vm.iconStyle,
          inputClass: _vm.inputClass,
          debounceTime: 500,
          inputClasses: _vm.inputClasses,
          prefix: _vm.prefix,
          suffix: _vm.suffix,
        },
        on: {
          input: function ($event) {
            return _vm.handleInput("maxValue", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "h-input" }, [
      _c("p", { staticClass: "mx-3 w-3.5 text-storm-gray" }, [_vm._v(" ⎯ ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }